const imageStore = {}
let count = 0
export function loadImage(src, callback) {
  // console.log('src:', src)
  // console.log('count:', count)
  if (!src) return;
  // 下载成功或正在下载的直接返回，失败的则会再次下载
  const status = imageStore[src];
  if (status !== undefined) {
    if (status.isLoading || status.loaded) return;
  }
  // 进行下载
  if (count > 10) return;
  imageStore[src] = {
    isLoading: true,
  }
  count++;
  const img = new Image();
  img.src = src;

  img.onload = function () {
    imageStore[src] = { isLoading: false, loaded: true };
    count--;
    // console.log('success-count:', count)
    callback(true)
  }
  img.onerror = function () {
    imageStore[src] = { isLoading: false, loadError: true };
    count--;
    // console.log('error-count:', count)
    callback(false)
  }
}

export function isImageLoaded(src) {
  return (imageStore[src || 'default'] || {}).loaded;
}
